<div class="snack"
     [ngClass]=" { 'small': size === snackSize.Small, 'large': size === snackSize.Large, 'd-none': size === snackSize.Hidden }">
    <div class="snack-content"
         [class.spinner]="!details.progress"
         [ngClass]="{ 'complete': details.isComplete && (!details.canDownload || (details.canDownload && !details.isOwner)) && !details.progressFailure, 'active': !details.isComplete, 'error': details.progressFailure }">
        <div class="details large"
             [class.has-actions]="!details.cancelling && !details.downloading && (details.progressFailure || details.canCancel || details.isComplete)"
             [class.disconnected]="signalRDisconnected">
            <div class="icon-body">
                <div class="icon-container">
                    @if (!details.isComplete || (details.isComplete && details.downloading)) {
                        <span class="help-spinner">
                            <div class="la-ball-spin-clockwise la-oval">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </span>
                    }
                    @if (details.isComplete && (!details.canDownload || (details.canDownload && details.isOwner && !details.downloading)) && !details.progressFailure) {
                        <span class="snack-progress complete">
                            <i class="fa fa-check-circle-o"></i>
                        </span>
                    }
                    @if (details.progressFailure) {
                        <span class="snack-progress failed">
                            <i class="fa fa-times-circle-o"></i>
                        </span>
                    }
                    @if (details.isComplete && details.canDownload && !details.progressFailure && !details.isOwner && !details.downloading) {
                        <span class="snack-progress download" (click)="details.performDownload()">
                            <i class="fa fa-download"></i>
                        </span>
                    }
                </div>
                <div class="action-icons">
                    @if (details.isComplete && (!details.canDownload || (details.canDownload && details.isOwner && !details.downloading)) && !details.progressFailure) {
                        <span class="snack-progress complete">
                            <i class="fa fa-check-circle-o"></i>
                        </span>
                    }
                    @if (showCancel && !details.isComplete) {
                        <span class="snack-progress">
                            <i class="fa fa-trash"></i>
                        </span>
                    }
                    @if (details.isComplete && details.canDownload && !details.progressFailure && !details.isOwner) {
                        <span class="snack-progress download" (click)="details.performDownload()">
                            <i class="fa fa-download"></i>
                        </span>
                    }
                    @if (details.progressFailure) {
                        <span class="snack-progress failed">
                            <i class="fa fa-times-circle-o"></i>
                        </span>
                    }
                </div>
            </div>

            <div class="snack-body">
                <div class="snack-progress-container"
                     [class.active]="details.progress && loadingWaitComplete && !signalRDisconnected">
                    <div class="snack-progress-bar"
                         [class.failed]="details.progressFailure"
                         [class.complete]="details.isComplete || details.isCancelled"
                         [ngStyle]="{ 'transform': 'skew(-20deg) translateX(' + (-(100 - details.progress)) + '%)' }"></div>
                </div>
                <div class="snack-body-content ws-flex-container-horizontal">
                    <div class="text-container">
                        @if (!signalRDisconnected || details.isComplete) {
                            <span class="primary-text">{{ details.title }}</span>
                        }
                        @if (signalRDisconnected && !details.isComplete) {
                            <span class="primary-text">Status not detected</span>
                        }
                        @if (details.message && (!signalRDisconnected || details.isComplete)) {
                            <span class="secondary-text">{{ details.message }}</span>
                        }
                    </div>
                    <div class="action-container ws-flex-container-vertical">
                        @if (details.isComplete && details.canDownload && !details.progressFailure && !details.isOwner) {
                            <span (click)="details.performDownload()">
                                Download
                            </span>
                        }
                        @if (showCancel && !details.isComplete) {
                            <span class="cancel"
                                  [class.disabled]="cancelDisabled"
                                  (click)="details.performCancel()">
                                Cancel
                            </span>
                        }
                        @if (details.canNavigate && details.isComplete && !details.progressFailure) {
                            <span class="navigate" (click)="details.performNavigate()">
                                Navigate
                            </span>
                        }
                        @if ((!details.canDownload && details.isComplete) || details.progressFailure || details.isCancelled) {
                            <span (click)="details.performDismiss()">
                                Click to dismiss
                            </span>
                        }
                        @if (!details.isComplete && signalRDisconnected) {
                            <span (click)="refreshFromLRPServer()">
                                Refresh @if (manualUpdateLoading) {
                                <i class="fa fa-spinner fa-pulse lrp-check-spin"></i>
                            }
                            </span>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="details small"
             [ngClass]="{ 'complete': details.isComplete && (!details.canDownload || (details.canDownload && details.isOwner && !details.downloading)) && !details.progressFailure, 'active': (!details.progress && !details.isComplete) || (details.isComplete && details.downloading), 'error': details.progressFailure }">
            @if (!details.progress && !details.isComplete) {
                <span class="snack-progress"><ws-ace-loader [inline]="true"></ws-ace-loader></span>
            }
            @if (details.progress && !details.isComplete) {
                <span class="snack-progress percent">{{ details.progress }}%</span>
            }
            @if (details.isComplete) {
                <span class="snack-progress complete">
                    @if (!details.progressFailure) {
                        <i class="fa fa-check-circle-o"></i>
                    }
                    @if (details.progressFailure) {
                        <i class="fa fa-times-circle-o failed"></i>
                    }
                </span>
            }
            <div class="text-container">
                <span class="primary-text">{{ details.title }}</span>
                @if (details.message) {
                    <span class="secondary-text">{{ details.message }}</span>
                }
            </div>
        </div>
    </div>
</div>

